import { IFilterValue } from '../api/types';

// TODO: update `key: string` to have some kind of a enumeration (each page should have enumerated filter keys)
export interface IFilterQueryItem {
  key: string;
  value: IFilterValue | IFilterValue[];
}

const FILTER_DELIMITER=';';
const FILTER_KEY_VALUE_DELIMITER = ':';
const FILTER_VALUE_DELIMITER = ',';

const formatFilterValue = (filterValue: IFilterValue | IFilterValue[]): string =>
  Array.isArray(filterValue)
    ? `[${filterValue.map(v => encodeURIComponent(String(v))).join(FILTER_VALUE_DELIMITER)}]`
    : encodeURIComponent(String(filterValue));

const formatFilter = (filterKey: string, filterValue: IFilterValue | IFilterValue[]): string =>
  `${filterKey}${FILTER_KEY_VALUE_DELIMITER}${formatFilterValue(filterValue)}`;

export const createFilterQueryString = (filters: IFilterQueryItem[]): string => {
  const queryString = filters.reduce(
    (acc, cur) =>
      acc ? `${acc}${FILTER_DELIMITER}${formatFilter(cur.key, cur.value)}` : formatFilter(cur.key, cur.value),
    ''
  );

  return encodeURIComponent(queryString);
};
